<div class="flex items-center gap-x-2">
  <div
    [ngClass]="bgLogo"
    class="flex items-center justify-center w-9 h-9 border-[1px] border-primary rounded-full">
    <app-svg-icon
      src="assets/common/icons/balance.svg"
      [class]="'stroke-' + colorLogo"></app-svg-icon>
  </div>
  <div class="flex flex-col md:flex-row items-center h-9">
    <span class="font-app-bold text-darkest md:ml-1">{{ "contractCard.titlePJ" | translate }}</span>
  </div>
</div>
